import { Button, styled } from '@mui/material';

export const RoundedButton = styled(Button)({
  borderRadius: 12,
  textTransform: 'none',
  boxShadow: 'none',
  paddingLeft: '12px',
  paddingRight: '12px',
});
